export function BigQueryIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.37956 21.3004L0.580133 12.9872C0.395607 12.6676 0.298462 12.305 0.298462 11.936C0.298462 11.5669 0.395607 11.2044 0.580133 10.8848L5.37956 2.57181C5.56411 2.25215 5.82956 1.98671 6.14922 1.80217C6.46888 1.61763 6.83149 1.52049 7.2006 1.52051H16.7994C17.1685 1.52052 17.5311 1.61768 17.8507 1.80222C18.1703 1.98676 18.4358 2.25218 18.6203 2.57181L23.4197 10.8848C23.6043 11.2044 23.7015 11.567 23.7015 11.9361C23.7015 12.3052 23.6043 12.6678 23.4197 12.9874L18.6203 21.3004C18.4357 21.6199 18.1703 21.8853 17.8507 22.0698C17.5311 22.2544 17.1685 22.3515 16.7994 22.3515H7.2006C6.83149 22.3515 6.46887 22.2544 6.14921 22.0698C5.82954 21.8853 5.5641 21.62 5.37956 21.3004Z"
        fill="url(#paint0_linear_2013_15901)"
      />
      <path
        opacity="0.07"
        d="M22.0978 16.0462L15.0397 8.98763L12 8.17419L9.26974 9.18893L8.21533 11.936L9.06314 14.9947L16.548 22.4796L18.1363 22.409L22.0978 16.0462Z"
        fill="black"
      />
      <path
        d="M12 7.69495C9.6579 7.69495 7.75916 9.59369 7.75916 11.936C7.75916 14.2781 9.6579 16.1769 12 16.1769C14.3421 16.1769 16.2407 14.2781 16.2407 11.936C16.2407 9.59369 14.342 7.69495 12 7.69495ZM12 15.1537C10.2229 15.1537 8.78212 13.713 8.78212 11.9358C8.78212 10.1587 10.2229 8.71809 12 8.71809C13.7772 8.71809 15.2179 10.1588 15.2179 11.936C15.2179 13.7132 13.7772 15.1537 12 15.1537Z"
        fill="white"
      />
      <path
        d="M9.98706 11.7722V13.0904C10.1821 13.4253 10.4573 13.7064 10.7879 13.9086V11.7722H9.98706ZM11.575 10.6609V14.2099C11.7112 14.235 11.8505 14.2501 11.9937 14.2501C12.1242 14.2501 12.2515 14.2364 12.3764 14.2156V10.6609H11.575ZM13.2371 12.3199V13.8854C13.573 13.6718 13.8488 13.376 14.0383 13.026V12.3201L13.2371 12.3199ZM15.0518 14.5481L14.6124 14.9879C14.5752 15.0252 14.5543 15.0757 14.5543 15.1284C14.5543 15.1811 14.5752 15.2316 14.6124 15.2689L16.279 16.9349C16.3163 16.9721 16.3668 16.993 16.4195 16.993C16.4722 16.993 16.5227 16.9721 16.56 16.9349L16.9993 16.4957C17.0363 16.4583 17.0571 16.4079 17.0571 16.3553C17.0571 16.3027 17.0363 16.2523 16.9993 16.2149L15.3326 14.5481C15.2953 14.5111 15.2448 14.4903 15.1922 14.4903C15.1396 14.4903 15.0891 14.5111 15.0518 14.5481Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2013_15901"
          x1="12"
          y1="1.52069"
          x2="12"
          y2="22.3191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4387FD" />
          <stop offset="1" stopColor="#4683EA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
